import { render, staticRenderFns } from "./DgStatus.vue?vue&type=template&id=57de8391"
import script from "./DgStatus.vue?vue&type=script&lang=js"
export * from "./DgStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports